import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Tag } from '../../molecules';
export const AccountTag = memo(({ value, closed = false }) => {
    return (_jsx(Tag, { label: closed ? 'Closed' : value, variant: closed ? 'info' : 'neutral' }));
});
